module.exports = __webpack_public_path__ + "img/title-notice.9f02b398.svg";